import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';

import './Join.css';

const Join = () => {
  const navigate = useNavigate();
  const form = useRef();

  // Renamed the function to handleSubmit to reflect the form action
  const handleSubmit = (e) => {
    // 1. Prevent the default form submission (which causes a page reload)
    e.preventDefault(); 
    
    const formElement = form.current;

    // The 'required' attribute on the input usually handles the empty check, 
    // but we can keep a manual check here if needed, or rely on browser validation.
    const emailValue = formElement.user_email.value;
    
    // Manual check for demonstration, often not necessary if 'required' is used
    if (!emailValue) {
      alert("Please enter your email address.");
      return;
    }
    
    // Check for basic email format validity (optional, browser handles this with type="email")
    // Note: You can add more robust validation here if desired.
    
    console.log("Attempting to send email for: ", emailValue);
    
    // Your EmailJS credentials and parameters
    const serviceId = 'service_ha93mbo';
    const templateId = 'template_1vd4azr';
    const publicKey = 'YpGbnDeKGMjPt9Eab'
    const templateParams = {
      user_email: emailValue,
      user_message: "hi" // Ensure your EmailJS template uses this 'text' variable if you intend to send it.
    }

    // 2. Send the email
    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then(
        () => {
          console.log("Email Sent Successfully!");
          alert("Thank you! Your email has been submitted.");
          formElement.reset(); // Reset the form fields on success
          // Optional: navigate('/success-page');
        },
        (error) => {
          console.log("Failed...", error);
          alert("Error sending email. Check console.");
        }
      );
  };

  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text">WITH US?</span>
        </div>
      </div>

      <div className="right-j">
        {/* 3. Attach handleSubmit to the form's onSubmit event */}
        <form ref={form} className="email-container" onSubmit={handleSubmit}> 
          <input 
            type="email"
            name="user_email"
            placeholder="Enter your email address"
            required
          />

          {/* 4. Change button type to 'submit' to trigger form submission */}
          <button 
            type="submit" 
            className="btn btn-j" 
          >
            Join Now
          </button>
        </form>
      </div>
    </div>
  );
};

export default Join;